import { ProductSection } from 'ProductSectionAccessPermissions/Types';

const ProductSectionNames: Partial<Record<ProductSection, string>> = {
  [ProductSection.LoanOriginationSystemApplications]: 'Applications',
  [ProductSection.LoanOriginationSystemEmails]: 'Emails',
  [ProductSection.LoanOriginationSystemTasks]: 'Tasks',
};

export default ProductSectionNames;
